import { ViewerCommand } from './ViewerCommand';
export class AddObjectCommand extends ViewerCommand {
    constructor(objects, viewer) {
        super(viewer, objects);
        this.type = 'AddObjectCommand';
        this.name = this.composeName();
    }
    execute() {
        this.viewer.addObjects(this.objects);
    }
    undo() {
        this.viewer.removeObjects(...this.objects);
    }
    update(cmd) {
        throw new Error(`${this.type} can not be updated`);
    }
}
